import { h } from 'preact';
import { BaseModal, show } from 'utils/modal';
import { joinClasses } from 'utils/utils';

import s from 'utils/addGuestModal.scss';

function maybeParse(value) {
	try {
		return JSON.parse(value);
	} catch (e) {
		return value;
	}
}

class AddGuestModal extends BaseModal {
	constructor(props) {
		super(props);
		this.decreaseCount = this.offsetCount.bind(this, -1);
		this.increaseCount = this.offsetCount.bind(this, 1);
	}

	offsetCount(amount) {
		const input = this.base.querySelector('input[name="count"]');
		input.value = Math.max(1, (+input.value || 0) + amount);
	}

	onSubmit(e) {
		const submitter = e.submitter || document.activeElement;
		if (submitter?.value === 'cancel') {
			return;
		}
		e.preventDefault();
		const data = new FormData(e.target);
		const name = data.get('name');
		const count = +data.get('count');
		const type = data.get('type');
		if (!name || !count || !type) {
			// Should not happen thanks to `required` but just in case
			return;
		}
		this.base?.closest('dialog')?.close(JSON.stringify({ name, count, type }));
	}

	renderTitle() {
		return this.props.title || 'ADD GUEST';
	}

	renderContent() {
		return [
			<label class={joinClasses(s.field, s.name)}>
				<span class={s.label}>Name</span>
				<div class={s.inputWrapper}><input name="name" required /></div>
			</label>,
			<label class={joinClasses(s.field, s.count)}>
				<span class={s.label}>How many guests?</span>
				<div class={s.inputWrapper}>
					<button type="button" class={s.decrease} onClick={this.decreaseCount} />
					<input type="number" name="count" value="1" min="1" required />
					<button type="button" class={s.increase} onClick={this.increaseCount} />
				</div>
			</label>,
			<label class={joinClasses(s.field, s.type)}>
				<span class={s.label}>Category</span>
				<div class={s.inputWrapper}>
					<select name="type" required>
						<option value="vip">Talent & VIP</option>
						<option value="staff">Amazon Staff</option>
						<option value="friend">Friends & Family</option>
						<option value="partner">Corporate & Promo Partners</option>
						<option value="student">Prime Student</option>
					</select>
				</div>
			</label>
		];
	}
}

export async function showAddGuestModal(options) {
	let result = await show(
		<AddGuestModal
			title={options?.title}
		/>,
		options
	);
	return result === 'cancel' ? null : maybeParse(result);
}